import React, { useEffect, useState } from "react";
import API from "../api";
import Layout from "../components/Layout";
import { FaEdit, FaTrash } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/style.css";

const Users = () => {
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editId, setEditId] = useState(null);

    // NEW STATES
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);

    const [form, setForm] = useState({
        name: "",
        phone: "",
        address: "",
        email: "",
        reason: "",
        remarks: ""
    });

    useEffect(() => {
        fetchUsers();
    }, []);

    // reset page on search/limit change
    useEffect(() => {
        setPage(1);
    }, [search, limit]);

    const fetchUsers = async () => {
        const res = await API.get("/users");
        setUsers(res.data);
    };

    // CREATE / UPDATE
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {

            if (editId) {
                await API.put(`/users/${editId}`, form);
                toast.success("Customer Updated");
            } else {
                await API.post("/users", form);
                toast.success("Customer Created");
            }

            setShowModal(false);
            setEditId(null);
            setForm({
                name: "", phone: "", address: "", email: "", reason: "", remarks: ""
            });

            fetchUsers();
        } catch (err) {
            toast.error(err.response?.data?.message || "Error");
        }
    };

    // DELETE
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure to delete?")) return;

        try {
            await API.delete(`/users/${id}`);
            toast.success("Customer Deleted");
            fetchUsers();
        } catch (err) {
            toast.error("Delete failed");
        }
    };

    // EDIT
    const handleEdit = (u) => {
        setForm(u);
        setEditId(u._id);
        setShowModal(true);
    };

    // FILTER
    const filtered = users.filter(u => {
        const keyword = search.toLowerCase();

        return (
            u.name?.toLowerCase().includes(keyword) ||
            u.address?.toLowerCase().includes(keyword) ||
            u.phone?.toLowerCase().includes(keyword)
        );
    });

    // PAGINATION
    const perPage = Number(limit);
    const start = (page - 1) * perPage;
    const current = filtered.slice(start, start + perPage);
    const totalPages = Math.ceil(filtered.length / perPage);

    return (
        <Layout>
            <ToastContainer position="top-right" autoClose={3000} />

            {/* TOPBAR */}
            <div className="topbar">
                <h2>Customer Information</h2>
                <button className="add-btn" onClick={() => setShowModal(true)}>
                    + Add Customer
                </button>
            </div>

            <div className="table-section">

                {/* SEARCH + LIMIT */}
                <div className="table-controls">
                    <div>
                        Show
                        <select value={limit} onChange={(e) => setLimit(e.target.value)}>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                        </select>
                        entries
                    </div>

                    <input
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                {/* TABLE */}
                <div className="table-responsive">
                    <table className="users-table">
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Customer Name</th>
                                <th>Mobile No</th>
                                <th>Date</th>
                                <th>Address</th>
                                <th>Email</th>
                                <th>Reason</th>
                                <th>Remarks</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>
                            {current.map((u, i) => (
                                <tr key={u._id}>
                                    <td>{start + i + 1}</td>
                                    <td>{u.name}</td>
                                    <td>{u.phone}</td>
                                    <td>
                                        {new Date(u.date || u.createdAt).toLocaleDateString()}
                                    </td>
                                    <td>{u.address}</td>
                                    <td>{u.email || "-"}</td>
                                    <td>{u.reason || "-"}</td>
                                    <td>{u.remarks || "-"}</td>

                                    <td className="actions">
                                        <button className="edit-btn" onClick={() => handleEdit(u)}>
                                            <FaEdit />
                                        </button>
                                        <button className="delete-btn" onClick={() => handleDelete(u._id)}>
                                            <FaTrash />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* PAGINATION */}
                <div className="pagination">
                    <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                        Prev
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i}
                            className={page === i + 1 ? "active" : ""}
                            onClick={() => setPage(i + 1)}
                        >
                            {i + 1}
                        </button>
                    ))}

                    <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>
                        Next
                    </button>
                </div>

            </div>

            {/* MODAL */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{editId ? "Edit Customer" : "Add Customer"}</h3>
                            <span onClick={() => setShowModal(false)}>×</span>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <input name="name" placeholder="Customer Name" value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })} required />

                            <input name="phone" placeholder="Phone" value={form.phone}
                                onChange={(e) => setForm({ ...form, phone: e.target.value })} />

                            <input name="address" placeholder="Address" value={form.address}
                                onChange={(e) => setForm({ ...form, address: e.target.value })} required />

                            <input
                                name="email"
                                placeholder="Email"
                                value={form.email}
                                onChange={(e) => setForm({ ...form, email: e.target.value })}

                            />

                            <input
                                placeholder="Reason"
                                value={form.reason}
                                onChange={(e) => setForm({ ...form, reason: e.target.value })}
                            />

                            <input
                                placeholder="Remarks"
                                value={form.remarks}
                                onChange={(e) => setForm({ ...form, remarks: e.target.value })}
                            />

                            <div className="modal-actions">
                                <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>Cancel</button>
                                <button type="submit">{editId ? "Update" : "Create"}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

        </Layout>
    );
};

export default Users;